import * as React from 'react';
import { ComponentType } from 'react';

import {
  StaticSidebarComponent,
  StaticSidebarComponentOptions,
} from '@/lib/types';

import RelatedLinksRenderer from '@/hygraph/renderers/related-links.renderer';
import SearchAdventureRenderer from '@/hygraph/renderers/search-adventure.renderer';

const StaticSidebarComponentOptionsMap: Partial<
  Record<StaticSidebarComponentOptions, ComponentType<StaticSidebarComponent>>
> = {
  [StaticSidebarComponentOptions.SearchAdventures]: SearchAdventureRenderer,
  [StaticSidebarComponentOptions.RelatedLinks]: RelatedLinksRenderer,
};

export default function StaticSidebarComponentRenderer(
  props: StaticSidebarComponent
) {
  const RenderStaticComponent =
    StaticSidebarComponentOptionsMap[props.staticSidebarComponent];

  if (!RenderStaticComponent) return null;
  return <RenderStaticComponent {...props} />;
}
